var _path, _mask, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSeconds30 = function SvgSeconds30(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 47,
    viewBox: "0 0 37 47",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3037 14.4147L33.3288 11.5722C33.6963 11.0559 33.5736 10.342 33.0548 9.97663L30.0005 7.82704C29.4816 7.46236 28.7625 7.5844 28.3949 8.09987L26.3192 11.0133C24.7872 10.2998 23.1423 9.78869 21.4185 9.51653V8.33199C21.4185 7.5735 22.0431 6.95277 22.8063 6.95277H23.5718C24.3353 6.95277 24.9599 6.33213 24.9599 5.57431V1.37952C24.9599 0.621405 24.3353 0 23.5718 0H13.428C12.6652 0 12.0405 0.621405 12.0405 1.37952V5.57422C12.0405 6.33204 12.6652 6.95267 13.428 6.95267H14.1944C14.9573 6.95267 15.582 7.5734 15.582 8.3319V9.51644C13.7335 9.80857 11.9769 10.3742 10.3529 11.1688L8.29634 8.28347C7.92903 7.76732 7.21042 7.64595 6.6913 8.01063L3.63739 10.1603C3.11797 10.5258 2.99528 11.2397 3.36317 11.7562L5.43667 14.6668C2.07991 17.9965 0 22.5986 0 27.6745C0 37.8126 8.29935 46.0612 18.5001 46.0612C28.7011 46.0612 37 37.8126 37 27.6745C37 22.469 34.8125 17.763 31.3037 14.4147ZM18.5001 41.6487C10.7475 41.6487 4.44006 35.3794 4.44006 27.6744C4.44006 19.9689 10.7475 13.6999 18.5001 13.6999C26.2528 13.6999 32.5604 19.9689 32.5604 27.6744C32.5604 35.3794 26.2528 41.6487 18.5001 41.6487Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 20,
    height: 37
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 46,
    width: 20,
    height: 37,
    transform: "rotate(-180 37 46)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 27.5,
    r: 11.5,
    transform: "rotate(-180 17.5 27.5)",
    fill: "white"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeconds30, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Seconds30.86ccfbbf.svg";
export { ForwardRef as ReactComponent };